import { atomWithStorage } from 'jotai/utils';

export const authAtom = atomWithStorage('auth', null, undefined, {
  getOnInit: true,
});

export const requestIdAtom = atomWithStorage('requestID', null, undefined, {
  getOnInit: true,
});
